/* eslint-disable no-restricted-imports */
import { api } from './services/api';
import authenticationSlice from './services/authenticationSlice';
import { configureStore } from '@reduxjs/toolkit';

export const getStore = () =>
  configureStore({
    reducer: {
      [api.reducerPath]: api.reducer,
      authenticationSlice
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware)
  });
export const store = getStore();
export type RootState = ReturnType<typeof store.getState>;
